import React from 'react';
import { withRouter, Link } from 'react-router-dom'

import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import MenuItem from './../components/MenuItem';
import logo from './../images/ast-header-logo@2x.svg';
import WebAPI from '../api/WebAPI.js';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = { menulist: [] };
    this.handleLogout = this.handleLogout.bind(this);
  }
  componentWillMount() {
    //now fetch all menus.
    //this use redux to store it or use direct web api
    ///app/menus
    WebAPI.getData('/app/menus/accountoption', {})
      .then(res => {
        this.setState({ menulist: res.data })
      }
      ).catch(err => {})
  }
  handleLogout(event, link) {
    this.props.history.push(link);
  }

  render() {
    
    
    return (
        <div className="header-area d-flex justify-content-between align-items-center flex-shrink-0">
            <div className="logo-area">
              <img className="header-logo" src={logo} alt="logo" />
            </div>

            <div className="buttons-area">
                 {this.state.menulist.length > 0 ? (
                  <Dropdown as={ButtonGroup} align="start" drop="down" size='sm'>
                    <Dropdown.Toggle variant="light" id="account_options" className="btn btn-account">
                      Account Options
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {this.state.menulist.map((menu) => <MenuItem key={menu.id} menu={menu} />)}
                    </Dropdown.Menu>
                  </Dropdown>
                ) : null}

                <button className="btn btn-logout" type="submit" onClick={(e) => { this.handleLogout(e, window.env.appcontext + "/logout") }} >
                  Logout
                </button>
            </div>
          </div>
    );
  }
}

export default withRouter(Header);